<template lang="jade">
  label.multi-item-selector(:class="{'to-click': !disabled}", @click="clicked")
    input(type="checkbox", v-model="value", v-if="!disabled")
    span {{ showValue }}
</template>

<script>
export default {
  props: {
    useState: {required: true, type: String},
    item: {required: true, type: Object},
    uniqueKey: {type: String},
    disabled: {type: Boolean, 'default': false},
    formatName: {},
    clickItem: {type: Function, 'default': null}
  },
  computed: {
    showValue () {
      if (this.formatName) {
        return this.formatName(this.item)
      }
      return this.item.name || this.item[this.uniqueKey]
    },
    value: {
      get () {
        const allSelected = this.$getterUseState(this.useState).selected
        for (let i in allSelected) {
          let current = allSelected[i]
          if (this.item.id === current.id) {
            return true
          }
        }
        return false
      },
      set (newValue) {
        const allSelected = this.$getterUseState(this.useState).selected
        if (this.value === true) {
          this.$dispatchUseState(this.useState, {selected: allSelected.filter(i => i.id !== this.item[this.uniqueKey])})
        } else {
          this.$dispatchUseState(this.useState, {selected: [...allSelected, this.item]})
        }
      }
    }
  },
  methods: {
    clicked () {
      if (this.clickItem) {
        this.clickItem(this.item)
      }
    }
  }
}
</script>

<style scoped>
  .multi-item-selector { margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// MultiItemSelector.vue?dd986404